import "react-toastify/dist/ReactToastify.css";
import qs from "qs";

import { api } from "@/services";
import { buildUrl } from "../../utils/bindUrl";

import {
  IResponseListUsers,
  IResponseShowUser,
  IUser,
} from "../../interfaces/users";
import { IListParams } from "@/interfaces/serviceInterface";

const BASE = "/users";

const serialize = (params: Record<string, unknown>) =>
  qs.stringify(params, { arrayFormat: "brackets", skipNulls: true, encode: true });

type UserId = string | number;

type ListUsersParams = Pick<IListParams,"filter"|"includes"|"page"|"limit"|"select">;

export async function listUsers({ filter, includes, page, limit, select }: ListUsersParams) {
  const { data } = await api.get<IResponseListUsers>(BASE, {
    params: { filter, includes, page, limit, select },
    paramsSerializer: (p) => serialize(p as Record<string, unknown>),
  });
  return data;
}

export async function showUser({ id, includes }: { id: UserId; includes?: string[] }) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.get<IResponseShowUser>(url, {
    params: { includes },
    paramsSerializer: (p) => serialize(p as Record<string, unknown>),
  });
  return data;
}

export async function createUser({ user }: { user: IUser }) {
  const { data } = await api.post<IResponseShowUser>(BASE, { user });
  return data;
}

export async function updateUser({ id, user }: { id: UserId; user: Partial<IUser> }) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const { data } = await api.put<IResponseShowUser>(url, { user });
  return data;
}

export async function deleteUser(id: UserId, opts?: { signal?: AbortSignal }) {
  const url = buildUrl(`${BASE}/{id}`, { id });
  const resp = await api.delete(url, {
    signal: opts?.signal,
    validateStatus: () => true, // evita interceptor disparar toast de erro
  });
  return { status: resp.status, data: resp.data };
}
